import React, { Fragment, useState, useEffect } from "react";
import CustomTabs from "./CustomTabs";
import { Route, Switch } from "react-router-dom/cjs/react-router-dom";
import { ServiciosSuministroElectricoHistorialConsumos } from "./ServiciosSuministroElectricoHistorialConsumos";
import ServiciosSuministroElectricoHistorialFacturas from "./ServiciosSuministroElectricoHistorialFacturas";
import { ServiciosSuministroElectricoHistorialPagos } from "./ServiciosSuministroElectricoHistorialPagos";
import { ServiciosSuministroElectricoDetalleDeuda } from "./ServiciosSuministroElectricoDetalleDeuda";
import { ServiciosSuministroElectricoMiContrato } from "./ServiciosSuministroElectricoMiContrato";
import { useHistory } from "react-router-dom";

const tabs = [
  {
    title: "Historial de consumos",
    to: "/mis-servicios/suministro-electrico/historial-consumos",
  },
  {
    title: "Historial de facturas",
    to: "/mis-servicios/suministro-electrico/historial-facturas",
  },
  {
    title: "Historial de pagos",
    to: "/mis-servicios/suministro-electrico/historial-pagos",
  },
  {
    title: "Detalle de deuda",
    to: "/mis-servicios/suministro-electrico/detalle-deuda",
  },
];

export function EmpresasServiciosSuministroElectrico({
  location,
  privilegios,
  available,
  services,
  user,
  reloadServices,
  setSelectedSuministroElectrico,
  selectedSuministroElectrico,
  createActionNotification,
}) {

  const history = useHistory();
  useEffect(()=>{
    if(location.pathname == '/mis-servicios/suministro-electrico'){
      history.push("/mis-servicios/suministro-electrico/historial-consumos");
    }

  }, [location.pathname])

  return (
    <Fragment>
      <div className="section-title">
        <h1>Suministro Eléctrico</h1>
      </div>
      <CustomTabs tabs={tabs} location={location} />
      <Switch>
        <Route path="/mis-servicios/suministro-electrico/historial-consumos">
          <ServiciosSuministroElectricoHistorialConsumos
            services={
              services
                ? services.filter((s) => s.business_line_id === "7")
                : null
            }
            setSelectedService={setSelectedSuministroElectrico}
            selectedService={selectedSuministroElectrico}
            
          />
        </Route>
        <Route path="/mis-servicios/suministro-electrico/historial-facturas">
          <ServiciosSuministroElectricoHistorialFacturas 
            services={
              services
                ? services.filter((s) => s.business_line_id === "7")
                : null
            }
            setSelectedService={setSelectedSuministroElectrico}
            selectedService={selectedSuministroElectrico}
          />
        </Route>
        <Route path="/mis-servicios/suministro-electrico/historial-pagos">
          <ServiciosSuministroElectricoHistorialPagos
            services={
              services
                ? services.filter((s) => s.business_line_id === "7")
                : null
            }
            setSelectedSuministroElectrico={setSelectedSuministroElectrico}
            selectedSuministroElectrico={selectedSuministroElectrico}
          />
        </Route>
        <Route path="/mis-servicios/suministro-electrico/detalle-deuda">
          <ServiciosSuministroElectricoDetalleDeuda
            services={
              services
                ? services.filter((s) => s.business_line_id === "7")
                : null
            }
            setSelectedSuministroElectrico={setSelectedSuministroElectrico}
            selectedSuministroElectrico={selectedSuministroElectrico}
            user={user}
          />
        </Route>
      </Switch>
    </Fragment>
  );
}
